{
  "dashboard": "Tableau de bord du négociant",
  "portfolio": "Portefeuille",
  "transactions": "Transactions",
  "dashboard_page": {
    "title": "Tableau de bord du détenteur de crédits",
    "subtitle": "Gérez votre portefeuille de crédits carbone et suivez les opportunités du marché",
    "stats": {
      "total_credits_owned": "Total des crédits détenus",
      "credits_retired": "Crédits retirés",
      "portfolio_value": "Valeur du portefeuille",
      "active_transactions": "Transactions actives",
      "this_month": "ce mois-ci",
      "pending": "en attente"
    },
    "recent_transactions": {
      "title": "Transactions récentes",
      "view_all": "Voir tout",
      "purchased_credits": "Crédits achetés",
      "retired_credits": "Crédits retirés",
      "transferred_credits": "Crédits transférés",
      "project": "Projet",
      "to": "À",
      "retired": "Retiré"
    },
    "quick_actions": {
      "title": "Actions rapides",
      "buy_credits": "Acheter des crédits",
      "transfer_credits": "Transférer des crédits",
      "retire_credits": "Retirer des crédits",
      "export_ledger": "Exporter le grand livre",
      "market_alert": "Alerte marché",
      "market_alert_message": "Forte demande de crédits forestiers. Envisagez de vendre aux taux actuels du marché."
    },
    "portfolio_breakdown": {
      "title": "Répartition du portefeuille",
      "renewable_energy": "Énergie renouvelable",
      "forestry_land_use": "Foresterie et utilisation des terres",
      "energy_efficiency": "Efficacité énergétique",
      "other": "Autre",
      "credits": "crédits"
    },
    "market_insights": {
      "title": "Aperçu du marché",
      "average_credit_price": "Prix moyen du crédit",
      "trading_volume": "Volume des transactions",
      "new_projects": "Nouveaux projets",
      "from_last_week": "depuis la semaine dernière",
      "credits_traded_this_week": "Crédits échangés cette semaine",
      "registered_this_month": "Enregistré ce mois-ci"
    }
  },
  "register_page": {
    "breadcrumb": {
      "home": "Accueil",
      "registration": "Inscription",
      "credit_holder_trader": "Détenteur de crédit / Négociant"
    },
    "header": {
      "title": "Inscription détenteur de crédit / négociant",
      "subtitle": "Inscrivez-vous pour acheter, échanger et retirer des crédits carbone sur le registre SOR"
    },
    "personal_info": {
      "title": "Informations personnelles",
      "full_name_org": "Nom complet / Nom de l'organisation",
      "full_name_placeholder": "Entrez votre nom complet ou le nom de votre organisation",
      "country": "Pays",
      "select_country": "Sélectionnez votre pays",
      "email_address": "Adresse e-mail",
      "email_placeholder": "votre.email{'@'}exemple.com",
      "phone_number": "Numéro de téléphone",
      "phone_placeholder": "+1 (555) 123-4567"
    },
    "intended_use": {
      "title": "Utilisation prévue",
      "buy_credits": {
        "title": "Acheter des crédits",
        "description": "Acheter des crédits carbone pour la conformité ou la compensation volontaire"
      },
      "trade_credits": {
        "title": "Échanger des crédits",
        "description": "Participer au négoce de crédits carbone et aux activités de marché"
      },
      "retire_credits": {
        "title": "Retirer des crédits",
        "description": "Retirer définitivement des crédits pour des déclarations environnementales"
      }
    },
    "account_security": {
      "title": "Sécurité du compte",
      "password": "Mot de passe",
      "password_placeholder": "Créez un mot de passe fort",
      "password_requirements": "Doit comporter au moins 8 caractères avec des majuscules, des minuscules et des chiffres",
      "confirm_password": "Confirmez le mot de passe",
      "confirm_password_placeholder": "Confirmez votre mot de passe"
    },
    "terms_declarations": {
      "title": "Conditions et déclarations",
      "agree_terms": "J'accepte les",
      "terms_conditions": "Termes et conditions",
      "acknowledge_privacy": "Je reconnais la",
      "privacy_policy": "Politique de confidentialité",
      "comply_rules": "J'accepte de me conformer aux règles et réglementations du registre SOR",
      "marketing_consent": "Je consens à recevoir des mises à jour et des communications marketing"
    },
    "form_actions": {
      "create_account": "Créer un compte (gratuit)",
      "cancel": "Annuler"
    },
    "registration_info": {
      "title": "Informations d'inscription",
      "free_registration": "L'inscription est gratuite pour les détenteurs de crédits et les négociants",
      "unique_rin": "Vous recevrez un numéro d'identification de registre (RIN) unique après approbation",
      "email_verification": "La vérification par e-mail est requise pour activer votre compte",
      "approval_time": "L'approbation du compte prend généralement 1 à 2 jours ouvrables",
      "start_trading": "Vous pouvez commencer à négocier immédiatement après l'activation du compte"
    }
  },
  "sidebar": {
    "dashboard": "Tableau de bord",
    "credit_ledger": "Registre des crédits",
    "transfer_credits": "Transférer des crédits",
    "retire_credits": "Retirer des crédits",
    "market_explorer": "Explorateur de marché",
    "portfolio_analytics": "Analyses de portefeuille"
  }
}